const env = process.env.REACT_APP_FEATURE_FLAGS;

export const isProduction = env === 'production';
export const isNotProduction = env !== 'production';
export const isStaging = env === 'staging';
export const isDevelopment = env === 'development';
